// @flow

import styled from '@emotion/styled'
import * as React from 'react'
import Helmet from 'react-helmet'

import { colors } from '@toggl/style'

import { CookieWarning } from '../CookieWarning'

declare var process: WebProcess

export const LayoutRoot = ({
  title,
  description,
  children,
  ogImage,
  ogImageAlt,
  favicon,
}: {
  title?: string,
  description?: string,
  children: React.Node,
  ogImage?: string,
  ogImageAlt?: string,
  favicon?: string,
}): React.Element<typeof LayoutRoot> => (
  <StyledLayoutRoot>
    <Helmet
      htmlAttributes={{
        lang: 'en',
      }}
    >
      <title itemProp="name">{title}</title>
      <meta property="og:title" content={title} />
      <meta
        name="description"
        property="og:description"
        content={
          description ||
          'When time tracking is this easy, you can get more done. Toggl Track data brings clarity around profitability and helps you make better business decisions.'
        }
      />
      <meta
        property="og:image"
        content={ogImage || require('assets/toggl-track-main.jpg')}
      />
      {ogImageAlt && <meta property="og:image:alt" content={ogImageAlt} />}
      <meta name="twitter:card" content="summary_large_image" />
      <link
        rel="icon"
        type="image/png"
        href={favicon || require('assets/favicon-track.png')}
        sizes="32x32"
      />

      <link
        rel="preconnect"
        href={new URL(process.env.GATSBY_PUBLIC_PATH).origin}
      />
      <link
        rel="preconnect"
        href={new URL(process.env.GATSBY_PUBLIC_PATH).origin}
        crossOrigin="anonymous"
      />

      <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
      <link rel="dns-prefetch" href="https://www.googleadservices.com" />
      <link rel="dns-prefetch" href="https://googleads.g.doubleclick.net" />
      <link rel="dns-prefetch" href="https://stats.g.doubleclick.net" />
      <link rel="dns-prefetch" href="https://bat.bing.com" />
      <link rel="dns-prefetch" href="https://edge.fullstory.com" />
      <link rel="dns-prefetch" href="https://facebook.com" />
      <link rel="dns-prefetch" href="https://connect.facebook.net" />
      <link rel="dns-prefetch" href="https://px.ads.linkedin.com" />
      <link rel="dns-prefetch" href="https://rs.fullstory.com" />
      <link rel="dns-prefetch" href="https://snap.licdn.com" />
    </Helmet>
    {children}
    <CookieWarning />
  </StyledLayoutRoot>
)

const StyledLayoutRoot = styled.div`
  background-color: ${colors.darkPurple};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`
